import { GRID_NUMBER_CHECKBOX, LEDGER, NUMBER, PERCENTAGE } from 'common/constants/gridType';
import { GET_ENTER_DATA } from 'common/constants/inputs';
import { formatNumbers, toString } from 'utilities';
import cellAllowsEmpty from 'utilities/cellAllowsEmpty';

export const getCellViewerFormat = (cell: any, format: any) => {
  if (format && format !== cell.format) {
    if (cell.currencySpecification && format.currency.additionalCurrencies) {
      const additionalCurrency = format.currency.additionalCurrencies.find(
        (currency: { currencyType?: string }) => currency.currencyType === cell.currencySpecification
      );
      return {
        ...format,
        currency: {
          ...format.currency,
          sourceCurrency: additionalCurrency?.sourceCurrency,
          symbol: additionalCurrency?.symbol,
          exchangeRate: additionalCurrency?.exchangeRate,
        },
      };
    }
    return format;
  }
  return {};
};

export const getCellViewerDisplayValue = (cell: any, cellFormat: any) => {
  if (cell.expr === '=') {
    return '=';
  }

  if (cell.hidden) {
    return '';
  }

  const isNumeric =
    [NUMBER, PERCENTAGE, GRID_NUMBER_CHECKBOX].includes(cell.gridType as string) && !isNaN(Number(cell.value));

  if (isNumeric) {
    if (!cell.readOnly && !toString(cell.value).length) {
      return cell.enterDataMessage ?? GET_ENTER_DATA(cell.isRequired, cell.enterDataMessage);
    }
    if (cell.readOnly && cellAllowsEmpty(cell) && !toString(cell.value).length) {
      return '';
    }
    const mergedCurrencyFormat = {
      currency: {
        ...cellFormat?.currency,
        ...cell.customFormat?.currency,
      },
    };
    return formatNumbers({
      ...cell,
      ...cellFormat,
      ...cell.customFormat,
      ...mergedCurrencyFormat,
    });
  }

  if (cell.gridType === LEDGER) {
    return 0;
  }

  if (!cell.readOnly && !cell.hidden && !cell.value && cell.placeholder) {
    return cell.placeholder;
  }
  return cell.value;
};

export const getCellViewerSpanId = (cell: any) => {
  if (cell.extraAttr) {
    return `${cell.extraAttr}-${cell.alias}-${cell.key}_viewer`;
  }
  return `${cell.alias}-${cell.key}_viewer`;
};
